module.exports = __webpack_public_path__ + "img/MDMyyjz.d37e1ed1.jpg";